import { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Classes } from '@blueprintjs/core';
import { DataAccessContext } from '@axo/shared/data-access/provider';
import { ace_hooks } from '@axo/shared/data-access/hooks';
import { HumanReadableID } from '../../HumanReadableID';
import { MenuNode } from './menuNode';
import styles from './styles.module.css';

export function useWorkQueueNodes(marketCountry: string): MenuNode[] {
  const navigate = useNavigate();

  const { state } = useContext(DataAccessContext);
  const queue = ace_hooks.useWorkQueue(state.user.clientID, marketCountry);

  const ids = useMemo(
    () => queue.data?.map((item) => item.LoanApplicationID) ?? [],
    [queue.data],
  );

  const nodes = useMemo<MenuNode[]>(() => {
    if (ids.length < 1) {
      return [
        {
          id: '3D4E8CCA-91E9-44DC-B669-7853C172C88C',
          label: 'No applications',
          className: Classes.TEXT_MUTED,
        },
      ];
    }

    return ids.map((id) => ({
      id: 'work-queue/' + id,
      label: <HumanReadableID id={id} />,
      className: styles.clickable,
      nodeData: {
        onClick: () => navigate(`/application/${id}`),
      },
    }));
  }, [ids, navigate]);

  return useMemo(
    () => [
      {
        id: '365E0E31-D258-40A5-BCB5-152E4E8A4DBB',
        hasCaret: true,
        icon: 'sort',
        label: 'Work queue',
        secondaryLabel: `(${ids.length})`,
        className: styles.clickable,
        childNodes: nodes,
      },
    ],
    [nodes, ids.length],
  );
}
